<template>
    <div>
        <!--
	  <div class="controls" style="margin-bottom: 8px; display: flex; gap: 8px; align-items: center; flex-wrap: wrap;">
		  <button @click="openScanner">Start</button>
		  <button @click="closeScanner">Stop</button>
		  <span v-if="!isSecure" style="color: #b00020;">Wymagany HTTPS lub uruchom na localhost.</span>
		</div>
		<div @click="test">test</div>
	-->
        <!--
		<div class="diagnostics" style="margin-top: 8px;">
			<div v-if="lastDecoded"><strong>Odczytano:</strong> {{ lastDecoded }}?token={{this.token}}</div>
			<div v-if="lastError" style="color: #b00020;">
				<strong>Błąd:</strong> {{ lastErrorMessage }}
			</div>
		</div>
	-->
        <div class="TopBar">
            <router-link :to="navigateToList">
                <img class="" src="@/assets/images/logo-dostartu-white.svg" alt="Logo dostartu" />
            </router-link>
            <router-link :to="navigateToList">
                <img class="" src="@/assets/images/icons/home.svg" alt="Logo dostartu" />
            </router-link>
        </div>
        <scanner-q-r ref="scanner" :header-offset="48" @decoded="onDecoded" @error="onScanError" />
        <div class="search-wrapper" @click="openSearchView">
            <div class="search-trigger">
                <i class="fas fa-search" />
                <span>Wyszukaj uczestnika lub nr startowy....</span>
            </div>
        </div>
        <div v-if="showSearchView" class="search-view">
            <div class="search-view-topbar">
                <router-link :to="navigateToList">
                    <img class="" src="@/assets/images/logo-dostartu-white.svg" alt="Logo dostartu" />
                </router-link>
            </div>
            <div class="search-input-container">
                <div class="search-input-wrapper">
                    <i class="fas fa-search"></i>
                    <input
                        ref="searchInput"
                        v-model="searchQuery"
                        type="text"
                        placeholder="Wyszukaj uczestnika lub nr startowy..."
                        class="search-input"
                    />
                </div>
            </div>
            <div class="participants-list-container">
                <div class="participants-list">
                    <div
                        v-for="participant in filteredParticipants"
                        :key="
                            participant.id ||
                            participant.playerNumber + '-' + participant.firstname + '-' + participant.lastname
                        "
                        class="participant-item"
                        @click="selectParticipant(participant)"
                    >
                        <div class="participant-info">
                            <div class="participant-name">{{ participant.firstname }} {{ participant.lastname }}</div>
                            <div class="participant-number">{{ participant.playerNumber }}</div>
                            <i class="fas fa-caret-right"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="search-view-close" @click="closeSearchView">
                <i class="fas fa-times"></i>
            </div>
        </div>
        <div class="info-box" :class="{ 'info-box--shown': showInfoBox }">
            <div v-if="infoLoading" class="info-box-header">
                <div style="display: flex; align-items: center; gap: 12px">
                    <span class="spinner spinner--small"></span>
                    <b>Synchronizacja danych…</b>
                </div>
            </div>
            <div v-else-if="infoStatus === 'noCamera'" class="info-box-header info-box-header--warning">
                <div>
                    <exclamation-mark fill="#455A64" />
                    <b>Brak dostępnej kamery</b>
                </div>
                <div>
                    <base-button btn2 @click="tryAgain"> spróbuj ponownie </base-button>
                </div>
            </div>
            <div v-else-if="infoStatus === 'permission'" class="info-box-header info-box-header--warning">
                <div>
                    <exclamation-mark fill="#455A64" />
                    <b>Odmowa dostępu do kamery</b>
                </div>
                <div>
                    <base-button btn2 @click="tryAgain"> spróbuj ponownie </base-button>
                </div>
            </div>
            <div v-else-if="infoStatus === 'insecure'" class="info-box-header info-box-header--warning">
                <div>
                    <exclamation-mark fill="#455A64" />
                    <b>Wymagany HTTPS lub uruchom na localhost</b>
                </div>
            </div>
            <template v-else>
                <div v-if="infoStatus === 'success'" class="info-box-header info-box-header--success">
                    <div>
                        <checkmark-circle />
                        <b>Wszystko w porządku, możesz wydać numer</b>
                    </div>
                </div>
                <div v-if="infoStatus === 'issued'" class="info-box-header info-box-header--success">
                    <div>
                        <checkmark-circle />
                        <b>Numer startowy został wydany</b>
                    </div>
                </div>
                <div v-if="infoStatus === 'alreadyIssued'" class="info-box-header info-box-header--error">
                    <div>
                        <exclamation-triangle />
                        <b>Numer startowy został już wydany</b>
                    </div>
                    <div style="width: 100%">
                        <base-button btn4 style="width: 100%; color: white" @click="revert"
                            >Cofnij wydanie numeru</base-button
                        >
                    </div>
                </div>
                <div v-if="infoStatus === 'noPlayerNumber'" class="info-box-header info-box-header--error">
                    <div>
                        <exclamation-triangle />
                        <b>Brak Numeru startowego</b>
                    </div>
                </div>
                <div v-if="infoStatus === 'reverted'" class="info-box-header">
                    <div>
                        <checkmark-circle fill="#455A64" />
                        <b>Wydanie numeru zostało cofnięnie.</b>
                    </div>
                </div>
                <div v-if="infoStatus === 'noFee'" class="info-box-header info-box-header--error">
                    <div>
                        <exclamation-triangle />
                        <b>Brak opłaty startowej</b>
                    </div>
                </div>
                <div
                    v-if="infoStatus === 'warning' || infoStatus === 'error'"
                    class="info-box-header info-box-header--warning"
                >
                    <div>
                        <exclamation-mark fill="#455A64" />
                        <b>Niepoprawny kod QR</b>
                    </div>
                </div>
                <div
                    ref="infoContent"
                    class="info-box-content"
                    :class="{ 'has-scroll': contentScrollable }"
                    @scroll="onContentScroll"
                >
                    <validation-observer
                        v-if="infoStatus === 'noPlayerNumber'"
                        v-slot="{ handleSubmit }"
                        ref="playerNumberFormObserver"
                        tag="div"
                    >
                        <form class="row add-person" @submit.prevent="handleSubmit(add)">
                            <validation-provider
                                v-slot="{ errors }"
                                name="playerNumber"
                                rules="required"
                                class="scroll-margin"
                            >
                                <base-input-text
                                    v-model="playerNumber"
                                    type="number"
                                    label="Numer startowy"
                                    class="form-input"
                                    :error.sync="errors[0]"
                                />
                            </validation-provider>
                        </form>
                    </validation-observer>
                    <div v-else>
                        <div>
                            <div class="label">Numer startowy</div>
                            <div class="text text-lg">{{ info.startNumber || '-' }}</div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div class="label">Uczestnik</div>
                            <div class="text text-lg">{{ info.participantName || '-' }}</div>
                        </div>
                        <!--
					<div class="flex-end">
						<div class="label">Wiek</div>
						<div class="text text-lg">{{ info.age || '-' }}</div>
					</div>
                    --></div>
                    <div>
                        <div>
                            <div class="label">Klasyfikacja</div>
                            <div class="text">{{ classification?.namePl || info.classification || '-' }}</div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div class="label">Nr chipa</div>
                            <div class="text">{{ info.chipNumber || '-' }}</div>
                        </div>
                        <div class="flex-end">
                            <div class="label">Nr GPS</div>
                            <div class="text">{{ info.gpsNumber || '-' }}</div>
                        </div>
                    </div>
                    <template v-if="info?.shopSales && info.shopSales.length > 0">
                        <hr />
                        <div>
                            <div>
                                <div class="label">Pakiet startowy</div>
                                <div class="shop-item-wrap">
                                    <div v-for="shop in info.shopSales" class="shop-item">
                                        <div>
                                            <div class="label">x{{ shop.items }}</div>
                                            <div class="text">{{ shop.shopProduct }}</div>
                                        </div>
                                        <div>
                                            <div class="label" style="text-align: right">{{ shop.model }}</div>
                                            <div class="text" style="text-align: right">
                                                <small v-if="!shop.pay" style="color: var(--color-pinky-red, red)"
                                                    >niezapłacone</small
                                                >
                                                {{ shop.amount }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="info?.notes">
                        <hr />
                        <div>
                            <div>
                                <div class="label">Notatka</div>
                                <div class="text">{{ info.notes || '-' }}</div>
                            </div>
                        </div>
                    </template>
                </div>
                <div
                    class="info-box-footer"
                    :style="{
                        '--shadow-opacity': contentScrollable ? shadowOpacity : 0,
                        '--shadow-height': contentScrollable ? shadowHeight + 'px' : '0px',
                    }"
                >
                    <base-button
                        v-if="infoStatus === 'noPlayerNumber'"
                        btn1
                        style="width: 100%"
                        @click="setPlayerNumber"
                        >Ustaw numer i wydaj pakiet</base-button
                    >
                    <base-button v-if="infoStatus === 'success'" btn1 style="width: 100%" @click="issueNumber"
                        >Wydaj numer</base-button
                    >
                    <base-button btn4 @click="closeInfoBox"> zamknij </base-button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import api from '@/api';
    import axios from 'axios';
    import ScannerQR from '@/components/ScannerQR.vue';
    import ExclamationMark from '@/components/icons/ExclamationMark.vue';
    import CheckmarkCircle from '@/components/icons/CheckmarkCircle.vue';
    import ExclamationTriangle from '@/components/icons/ExclamationTriangle.vue';
    import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
    import { required } from 'vee-validate/dist/rules';
    import { mapGetters } from 'vuex';
    import { IS_PRODUCTION_ENV } from '@/config';

    extend('required', {
        ...required,
        message: 'required_field',
    });

    export default {
        components: {
            ScannerQR,
            ExclamationMark,
            CheckmarkCircle,
            ExclamationTriangle,
            ValidationObserver,
            ValidationProvider,
        },
        props: {
            secureId: {
                type: String,
                required: true,
            },
        },
        beforeUnmount() {
            if (this.scrollEndTimer) {
                clearTimeout(this.scrollEndTimer);
                this.scrollEndTimer = null;
            }
        },
        data() {
            return {
                lastError: null,
                lastDecoded: null,
                showInfoBox: false,
                infoStatus: null,
                infoLoading: false,
                info: {
                    startNumber: null,
                    participantName: null,
                    age: null,
                    classification: null,
                    chipNumber: null,
                    gpsNumber: null,
                },
                classification: null,
                playerNumber: null,
                contentScrollable: false,
                contentAtBottom: true,
                shadowOpacity: 0,
                shadowHeight: 24,
                scrollEndTimer: null,
                pickUpPoint: '1',
                showSearchView: false,
                searchQuery: '',
                participants: [],
            };
        },
        computed: {
            ...mapGetters(['user']),
            isMobile() {
                return ['sm', 'md'].includes(this.$mq);
            },
            isSecure() {
                return typeof window !== 'undefined' ? window.isSecureContext : false;
            },
            lastErrorMessage() {
                if (!this.lastError) return '';
                return this.lastError?.message || String(this.lastError);
            },
            navigateToList() {
                if (this.user && this.user.roles.includes('ROLE_ADMIN')) {
                    return { name: 'panel-admin', alias: true };
                }
                if (this.user && this.user.roles.includes('ROLE_OPERATOR')) {
                    return { name: 'panel-operator', alias: true };
                }
                return { name: 'panel-organizer', alias: true };
            },
            filteredParticipants() {
                if (!this.searchQuery) return this.participants;
                const query = this.searchQuery.toLowerCase();
                return this.participants.filter(
                    (participant) =>
                        participant.firstname.toLowerCase().includes(query) ||
                        participant.lastname.toLowerCase().includes(query) ||
                        participant.playerNumber.toString().includes(query)
                );
            },
        },
        async created() {
            if (this.$route && this.$route.query && this.$route.query.pickuppoint) {
                this.pickUpPoint = this.$route.query.pickuppoint;
            } else {
                const urlParams = new URLSearchParams(window.location.search);
                const param = urlParams.get('pickuppoint');
                if (param) this.pickUpPoint = param;
            }
        },
        mounted() {
            if (this.isSecure) {
                this.openScanner();
            }
            this.readPlayerList();
            this.$nextTick(this.updateScrollIndicators);
        },
        methods: {
            onDecoded(code) {
                this.lastDecoded = code;
                this.lastError = null;
                this.processCode(code);
                //   console.log('Scanned QR Code:', code)
            },
            onScanError(err) {
                this.lastError = err;
                const t = this.classifyScanError(err);
                if (t === 'noCamera') {
                    this.infoStatus = 'noCamera';
                    this.showInfoBox = true;
                } else if (t === 'permission') {
                    this.infoStatus = 'permission';
                    this.showInfoBox = true;
                } else if (t === 'insecure') {
                    this.infoStatus = 'insecure';
                    this.showInfoBox = true;
                }
            },
            openScanner() {
                this.$refs.scanner.start();
            },
            closeScanner() {
                this.$refs.scanner.stop();
            },
            tryAgain() {
                this.showInfoBox = false;
                const s = this.$refs.scanner;
                if (!s) return;
                if (typeof s.restart === 'function') {
                    s.restart();
                    return;
                }
                if (typeof s.getState === 'function') {
                    const st = s.getState();
                    if (st && st.scanning && st.paused && typeof s.resume === 'function') {
                        s.resume();
                    } else if (typeof s.start === 'function') {
                        s.start();
                    }
                    return;
                }
                if (typeof s.start === 'function') {
                    s.start();
                }
            },
            test() {
                this.processCode(
                    'https://api.sandbox.dostartu.pl/qr/competition/10962/player/752ef1903e020724eb65cd66e14e17ba'
                );
            },
            updateScrollIndicators() {
                const el = this.$refs.infoContent;
                if (!el) return;
                this.contentScrollable = el.scrollHeight > el.clientHeight + 1;
                const remaining = Math.max(0, el.scrollHeight - (el.scrollTop + el.clientHeight));
                this.contentAtBottom = remaining <= 1;
                const threshold = 100;
                const ratio = Math.max(0, Math.min(1, remaining / threshold));
                const minH = 8;
                const maxH = 24;
                this.shadowOpacity = ratio;
                this.shadowHeight = Math.round(minH + (maxH - minH) * ratio);
            },
            onContentScroll() {
                this.updateScrollIndicators();
                if (this.scrollEndTimer) clearTimeout(this.scrollEndTimer);
                this.scrollEndTimer = setTimeout(() => {
                    this.updateScrollIndicators();
                }, 80);
            },
            classifyScanError(err) {
                const msg = (err && (err.message || err.name || String(err))) || '';
                if (/secure context|HTTPS|localhost|Skaner wymaga/i.test(msg)) return 'insecure';
                if (
                    err &&
                    (err.name === 'NotFoundError' ||
                        /Requested device not found/i.test(msg) ||
                        /Brak kamery/i.test(msg) ||
                        err.name === 'OverconstrainedError')
                )
                    return 'noCamera';
                if (err && (err.name === 'NotAllowedError' || /Permission|denied/i.test(msg))) return 'permission';
                if (err && err.name === 'NotReadableError') return 'permission';
                return 'other';
            },
            resolveQrUrl(url) {
                if (!url || IS_PRODUCTION_ENV) return url;
                try {
                    const parsed = new URL(url, window.location.origin);
                    if (!parsed.pathname.startsWith('/qr/')) return url;
                    return `${window.location.origin}/api${parsed.pathname}`;
                } catch (e) {
                    return url;
                }
            },
            async processCode(url) {
                if (!url || this.infoLoading) return;
                const apiUrl = `${this.resolveQrUrl(url)}?token=${this.secureId}`;
                this.infoLoading = true;
                this.infoStatus = 'loading';
                this.showInfoBox = true;
                try {
                    const res = await axios.get(apiUrl);

                    this.info = {
                        startNumber: res.playerNumber || null,
                        participantName: `${res.firstname} ${res.lastname}` || null,
                        age: res.playerAge || null,
                        classification: res.classification || null,
                        chipNumber: res.playerChip || null,
                        gpsNumber: res.playerGpsNumber || null,
                        notes: res.notes || null,
                        shopSales: res.shopSales || [],
                        apiUrl,
                    };
                    if (res.payedTime === null) {
                        this.infoStatus = 'noFee';
                    } else if (res.playerNumber === 0 || res.playerNumber === null) {
                        this.infoStatus = 'noPlayerNumber';
                    } else if (res.reverted === true) {
                        this.infoStatus = 'reverted';
                    } else if (res.confirmedQrAt) {
                        this.infoStatus = 'alreadyIssued';
                    } else {
                        this.infoStatus = 'success';
                    }
                    this.showInfoBox = true;
                } catch (e) {
                    this.infoStatus = 'warning';
                    this.showInfoBox = true;
                } finally {
                    this.infoLoading = false;
                    if (this.info.classification) {
                        this.readClassification(this.info.classification);
                    }
                    this.$nextTick(this.updateScrollIndicators);
                }
            },
            issueNumber() {
                this.changeStatus(this.info.apiUrl, { status: 0, playerNumber: this.info.startNumber });
            },
            async setPlayerNumber() {
                this.$refs.playerNumberFormObserver.validate().then((success) => {
                    if (!success) {
                        for (const key of Object.keys(this.$refs.playerNumberFormObserver.fields)) {
                            if (this.$refs.playerNumberFormObserver.fields[key].invalid) {
                                const y = this.$refs.playerNumberFormObserver.refs[key].$el.getBoundingClientRect().top;
                                this.$refs.playerNumberFormObserver.refs[key].$el.scrollIntoView({
                                    top: y,
                                    behavior: 'smooth',
                                });
                                return;
                            }
                        }
                    }
                    this.info.startNumber = this.playerNumber;
                    this.changeStatus(this.info.apiUrl, { status: 0, playerNumber: this.playerNumber }, false, false);
                });
            },
            async changeStatus(apiUrl, payload, reverted = false, closeInfoBox = false) {
                if (!apiUrl || !payload || this.infoLoading) return;
                this.infoLoading = true;
                this.infoStatus = 'loading';

                payload.pickupPoint = this.pickUpPoint;

                try {
                    await axios.post(apiUrl, payload);

                    if (reverted === true) this.infoStatus = 'reverted';
                    else this.infoStatus = 'issued';
                    if (closeInfoBox === true) this.closeInfoBox();
                } catch (e) {
                    this.infoStatus = 'error';
                } finally {
                    await this.readPlayerList();
                    this.infoLoading = false;
                }
            },
            async revert() {
                this.changeStatus(this.info.apiUrl, { status: 1 }, true);
            },
            async readPlayerList() {
                try {
                    await api.get(`/panel/competitions/${this.secureId}/players/lite`).then((response) => {
                        this.participants = response;
                    });
                } catch (e) {}
            },
            async readClassification(classificationId) {
                try {
                    await api.get(`/classifications/${classificationId}`).then((response) => {
                        this.classification = response.classification;
                    });
                } catch (e) {}
            },
            closeInfoBox() {
                this.showInfoBox = false;
                this.playerNumber = null;
                this.classification = null;
                this.info = {
                    startNumber: null,
                    participantName: null,
                    age: null,
                    classification: null,
                    chipNumber: null,
                    gpsNumber: null,
                    apiUrl: null,
                };
                if (this.$refs.scanner && typeof this.$refs.scanner.resume === 'function') {
                    this.$refs.scanner.resume();
                }
            },
            openSearchView() {
                this.showSearchView = true;
                this.$nextTick(() => {
                    if (this.$refs.searchInput) {
                        this.$refs.searchInput.focus();
                    }
                });
            },
            closeSearchView() {
                this.showSearchView = false;
                this.searchQuery = '';
            },
            selectParticipant(participant) {
                // this.closeSearchView();
                this.processCode(participant.qrLink);
            },
        },
    };
</script>

<style scoped>
    .TopBar {
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 12px;
        box-sizing: border-box;
        background: #37474f;
    }
    .search-wrapper {
        background: #37474f;
        width: calc(100% - 32px);
        border-radius: 12px;
        height: 56px;
        position: absolute;
        bottom: 16px;
        left: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 20;
    }
    .search-trigger {
        border-radius: 4px;
        display: flex;
        align-items: center;
        gap: 10px;
        width: calc(100% - 16px);
        height: 40px;
        background: #546e7a;
    }
    .search-trigger i {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
    }
    .info-box {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        color: var(--color-slate);
        z-index: 122;
        transform: translateY(100%);
        transition: transform 250ms ease;
    }
    .info-box--shown {
        transform: translateY(0);
    }
    .info-box-header {
        border-top-left-radius: 24px;
        border-top-right-radius: 24px;
        padding: 24px;
        background-color: #eceff1;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }
    .info-box-header--success {
        color: var(--color-white);
        background-color: var(--color-dark-pastel-green);
    }
    .info-box-header--error {
        color: var(--color-white);
        background-color: var(--color-lipstick);
    }
    .info-box-header--warning {
        background-color: #fff1cc;
    }
    .info-box-header > div,
    .info-box-content > div {
        display: flex;
        align-items: center;
        gap: 16px;
    }

    .info-box-content > div > div {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
    }

    .flex-end {
        align-items: flex-end;
    }

    .info-box-content {
        background-color: var(--color-white);
        padding: 24px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        max-height: 400px;
        overflow-y: scroll;
        position: relative;
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;
    }

    .info-box-footer {
        border-top: 1px solid #dbe3e6;
        background-color: var(--color-white);
        padding: 24px;
        display: flex;
        gap: 16px;
        position: relative;
    }

    .info-box-footer::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: calc(-1 * var(--shadow-height, 24px));
        height: var(--shadow-height, 24px);
        background: linear-gradient(to top, rgba(219, 227, 230, 0.8), rgba(255, 255, 255, 0));
        opacity: var(--shadow-opacity, 0);
        pointer-events: none;
        transition: opacity 150ms ease, height 150ms ease;
        will-change: opacity, height;
        z-index: 1;
    }

    .label {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0px;
    }
    .text {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0px;
    }
    .text-lg {
        font-family: 'Bariol Bold';
        font-size: 32px;
        line-height: 40px;
    }
    .spinner {
        width: 20px;
        height: 20px;
        border: 3px solid rgba(0, 0, 0, 0.1);
        border-top-color: var(--color-pinky-red);
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
    }
    .spinner--small {
        width: 18px;
        height: 18px;
        border-width: 2px;
    }
    .form-input {
        width: 100%;
        border: 1px solid var(--color-light-slate);
    }
    .shop-item-wrap {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-top: 12px;
    }
    .shop-item {
        display: flex;
        justify-content: space-between;
    }
    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
    .search-view {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #263238;
        z-index: 100;
        display: flex;
        flex-direction: column;
    }

    .search-view-topbar {
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 12px;
        box-sizing: border-box;
        background: #37474f;
    }

    .search-input-container {
        padding: 16px;
        background: #37474f;
    }

    .search-input-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        background: #546e7a;
        border-radius: 8px;
        padding: 12px 16px;
    }

    .search-input-wrapper i {
        color: #b0bec5;
        margin-right: 12px;
        font-size: 16px;
    }

    .search-input {
        flex: 1;
        background: transparent;
        border: none;
        outline: none;
        color: white;
        font-size: 16px;
        font-weight: 500;
    }

    .search-input::placeholder {
        color: #b0bec5;
    }

    .participants-list-container {
        flex: 1;
        overflow: hidden;
        background: #fff;
        padding: 4px;
    }

    .participants-list {
        height: 100%;
        overflow-y: auto;
        padding: 0;
    }

    .participant-item {
        background: #fff;
        border-bottom: 1px solid #dbe3e6;
        padding: 16px;
        margin-bottom: 8px;
        cursor: pointer;
    }

    .participant-item:last-child {
        margin-bottom: 0;
    }

    .participant-info {
        display: flex;
        align-items: center;
        color: var(--color-slate);
        gap: 4px;
    }

    .participant-name {
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
    }

    .participant-number {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        margin-left: auto;
        margin-right: 12px;
    }

    .search-view-close {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 50%;
        cursor: pointer;
        color: white;
        font-size: 16px;
        transition: background-color 0.2s ease;
    }

    .search-view-close:hover {
        background: rgba(255, 255, 255, 0.2);
    }
</style>
